<template>
	<ViewFeedItem class="view-feed-messagetothepeople">
		<template v-slot:header>&nbsp;</template>

		<template v-slot:action>&nbsp;</template>

		<template v-slot:body>
			<p class="type-large-paragraph">ChalkySticks is an evolving ecosystem for the world of pool.</p>
			<p class="type-large-paragraph">Update regularly to get access to new features.</p>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedMessageToThePeople extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-feed-messagetothepeople {
		text-align: center;
		text-wrap: pretty;

		header {
			display: none;
		}

		.body {
			padding: 2rem;
		}
	}
</style>
